import React, { SVGProps } from 'react'
const SvgAddReceipt = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#D5404A"
      fillRule="evenodd"
      d="M8.334 7.499a.833.833 0 0 0-.834.833v5a.833.833 0 1 1-1.666 0v-5a2.5 2.5 0 0 1 2.5-2.5h5a.833.833 0 0 1 0 1.667zM32.5 8.332a.833.833 0 0 0-.834-.833h-5a.833.833 0 0 1 0-1.667h5a2.5 2.5 0 0 1 2.5 2.5v5a.833.833 0 1 1-1.666 0zM31.667 32.501c.46 0 .833-.373.833-.833v-5a.833.833 0 1 1 1.666 0v5a2.5 2.5 0 0 1-2.5 2.5h-5a.833.833 0 0 1 0-1.667zM7.5 31.668c0 .46.373.833.834.833h5a.833.833 0 0 1 0 1.667h-5a2.5 2.5 0 0 1-2.5-2.5v-5a.833.833 0 1 1 1.666 0zM14.988 14.167a.15.15 0 0 0-.152.152V26.21l1.655-1.528a1.08 1.08 0 0 1 1.367-.08l2.033 1.478 1.831-1.465a1.08 1.08 0 0 1 1.24-.076l1.786 1.098v-11.32a.15.15 0 0 0-.152-.151zm-1.82.152c0-1.005.815-1.819 1.82-1.819h9.608c1.004 0 1.818.814 1.818 1.819v12.37a1.08 1.08 0 0 1-1.645.919l-2.328-1.433-1.859 1.488a1.08 1.08 0 0 1-1.31.03l-2.004-1.459-2.287 2.111a1.08 1.08 0 0 1-1.812-.793z"
      clipRule="evenodd"
    />
    <path
      fill="#D5404A"
      fillRule="evenodd"
      d="M16.125 20.001c0-.46.374-.833.834-.833h3.333a.833.833 0 0 1 0 1.667H16.96a.833.833 0 0 1-.834-.834M16.125 16.779c0-.46.374-.834.834-.834h5a.833.833 0 1 1 0 1.667h-5a.833.833 0 0 1-.834-.833"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgAddReceipt
